import(/* webpackMode: "eager" */ "C:\\Users\\Serhat Altun\\Downloads\\ser\\src\\app\\membership\\page.tsx");
